import Controller, { OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { DeckAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import BaseController from '../../BaseController';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { FragmentNames, SaeLocatorAliases } from '../../../codegen';
import './diagnosis-description.css';

@Controller({ fragment: FragmentNames.SAE_LOCATOR })
export default class SaeLocatorController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(SaeLocatorAliases.SAE_DECK)
    saeDeckApi!: DeckAPI;

  @Inject(SaeLocatorAliases.SAE_FILTER)
    filterSaeApi!: FilterAPI;

  @OnClick({ target: SaeLocatorAliases.SELECT_BUTTON })
  onSelectButtonClick(): void {

    const submitableEvent = {
      record: this.saeDeckApi.getSelectedCards()[0]
    };

    if (submitableEvent.record) {
      this.submittableFragmentContext.submit(new SubmitEvent(submitableEvent));
    }
  }

  @OnMount({ target: SaeLocatorAliases.LOCATOR_SAE_LAYOUT })
  onMountLayout(): void {
    this.filterSaeApi.restoreState(true);
  }

  @OnUnmount({ target: SaeLocatorAliases.SAE_FILTER })
  onFilterUnmount(event: MountEvent): void {
    const filterDisease = event.target as FilterAPI;
    filterDisease.persistState();
  }
}
